export default __webpack_public_path__ + "media/icon-default.f04c6f45e08e20a9100cec7fb55bd820.svg";